import { useThemeMode, systemMode } from '../../../../../../_metronic/partials'

// Apex draws inside the Metronic card, so it has to follow the theme itself: its
// default axis text is near-black and stays unreadable on the dark card, and any
// hard-coded light fill (empty heatmap cells, loading overlay) reads as a white
// patch. Every dashboard chart pulls its neutrals from here.
export type ChartTheme = {
  mode: 'light' | 'dark'
  /** Grid lines, borders, empty (zero) heatmap cells. */
  gridColor: string
  /** Text drawn on top of a neutral/empty surface. */
  mutedColor: string
  /** Day-change divider on a time axis — has to stay visible over bars/cells. */
  dividerColor: string
  /** Overlay above the chart while it reloads. */
  overlayBg: string
  /** Фон карточки — им же разделяются ячейки heatmap. */
  cardBg: string
}

const LIGHT: ChartTheme = {
  mode: 'light',
  gridColor: '#EFF2F5',
  mutedColor: '#B5B5C3',
  dividerColor: '#7E8299',
  overlayBg: 'rgba(255,255,255,0.6)',
  cardBg: '#FFFFFF',
}

const DARK: ChartTheme = {
  mode: 'dark',
  gridColor: '#2B2B40',
  mutedColor: '#565674',
  dividerColor: '#92929F',
  overlayBg: 'rgba(27,27,41,0.6)',
  cardBg: '#1E1E2D',
}

export function useChartTheme(): ChartTheme {
  const { mode } = useThemeMode()
  const resolved = mode === 'system' ? systemMode : mode
  return resolved === 'dark' ? DARK : LIGHT
}
